import { CircleAlert } from "lucide-react";
import { useTranslate } from "ra-core";

import { cn } from "@/lib/utils";

import { textoDatosQueFaltan } from "../dominio/completitud";
import type { Negocio } from "../dominio/tipos";

/**
 * Aviso «Faltan datos: …» (v1.1) en la ficha y en la tarjeta del tablero. Solo informa:
 * nunca bloquea ni abre ventanas. El texto sale de textoDatosQueFaltan (dominio).
 */
export const DatosQueFaltan = ({
  negocio,
  className,
}: {
  negocio: Pick<
    Negocio,
    "telefono" | "email" | "persona_contacto" | "es_decisor"
  >;
  className?: string;
}) => {
  const translate = useTranslate();
  const texto = textoDatosQueFaltan(translate, negocio);
  if (!texto) return null;
  return (
    <p
      className={cn(
        "flex items-center gap-1 text-xs text-amber-700 dark:text-amber-400",
        className,
      )}
    >
      <CircleAlert className="size-3.5 shrink-0" aria-hidden />
      <span className="truncate">{texto}</span>
    </p>
  );
};
